import React from "react";
import { List, Text } from "../../../components";

export const diferencaSorteioLance = {
  title: "Qual a diferença entre sorteio e lance?",
  body: (
    <>
      <Text textSize="sm">
        <strong>Sorteio</strong> é a apuração da cota sorteada, que é realizada
        mensalmente, com base no resultado da Loteria Federal anterior à data da
        assembleia. É importante lembrar que caso a parcela não esteja em dia,
        você não terá direito ao sorteio.
      </Text>

      <Text textSize="sm">
        <strong>Lance</strong> é uma forma de você aumentar a chance de ser
        contemplado antecipando parcelas do seu consórcio e pode ser feito de
        duas formas:
      </Text>
      <List styleType="disc">
        <li>
          <Text textSize="sm">
            <strong>Lance fixo:</strong> você oferece o valor fixo de 20% do que
            ainda falta pagar do seu consórcio. Será contemplado aquele que,
            entre todos, possuir a cota mais próxima da cota sorteada pela
            Loteria Federal.
          </Text>
        </li>
        <li>
          <Text textSize="sm">
            <strong>Lance livre:</strong> nesse tipo de lance você pode ofertar
            qualquer valor maior que sua parcela mensal. O lance é convertido em
            percentual e aquele que representar o maior valor será o
            contemplado. Em caso de empate, a cota contemplada será a de número
            mais próximo à cota sorteada.
          </Text>
        </li>
      </List>
      <Text textSize="sm">
        É possível utilizar parte do valor do crédito, até 50%, para dar o lance
        sem precisar ter dinheiro. Mas, se você quiser complementar a oferta de
        lance com o valor do crédito, suas chances de contemplação aumentam.
      </Text>
      <Text textSize="sm">
        Ah! Você pode ofertar lance fixo e livre na mesma assembleia. Aí terá
        três chances de ser contemplado - sorteio, lance fixo e lance livre. ;)
      </Text>
      <Text textSize="sm">
        Você receberá um comunicado quando for contemplado e ele será enviado
        apenas por e-mail e SMS.
      </Text>
    </>
  ),
};

export default null;
